const CryptoJS = require('crypto-js')
export const calcuAES = (pwd) => {
  let key = CryptoJS.enc.Latin1.parse('z0w5nB7VXMkpyvIW')
  let iv = CryptoJS.enc.Latin1.parse('z0w5nB7VXMkpyvIW')
  pwd = CryptoJS.AES.encrypt(pwd, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
  pwd = pwd.toString()
  return pwd
}



// WEBPACK FOOTER //
// ./src/util/aes.js